import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Set to true when technical work is underway
export const TECHNICAL_WORK_IN_PROGRESS = false;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
